import { render } from "./App.vue?vue&type=template&id=3c955a17&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3c955a17&scoped=true&lang=css"

import exportComponent from "/home/runner/work/talkvox_portal_v2/talkvox_portal_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c955a17"]])

export default __exports__